import styled from "styled-components";

export const HistoryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  text-align: center;
`;

export const ChangeLine = styled.div`
  font-size: 13px;
  line-height: 1.5;

  .field {
    font-weight: 600;
  }

  .before {
    color: rgba(0, 0, 0, 0.45);
    text-decoration: line-through;
  }

  .after {
    color: rgba(6, 142, 195, 1);
    font-weight: 600;
  }
`;
